import auth0 from 'auth0-js'
import authConfig from '@/auth_config.json'

export default class Authenticator {
  constructor () {
    this.auth0 = new auth0.WebAuth({
      domain: authConfig.domain,
      redirectUri: `${window.location.origin}/callback`,
      clientID: authConfig.clientId,
      audience: authConfig.audience,
      responseType: 'token id_token',
      scope: 'openid profile email'
    })
  }

  login (customState) {
    this.auth0.authorize({
      appState: customState
    })
  }

  logOut () {
    this.auth0.logout()
  }

  handleAuthentication () {
    const self = this
    return new Promise((resolve, reject) => {
      self.auth0.parseHash((err, authResult) => {
        if (err) return reject(err)

        resolve(authResult)
      })
    })
  }

  getAccessToken (accessToken, expiresAt) {
    return new Promise((resolve, reject) => {
      const self = this
      if (self.isAccessTokenValid(accessToken, expiresAt)) {
        resolve({accessToken, isExistingTokenValid: true})
      } else {
        self.renewTokens(accessToken).then(authResult => {
          resolve(authResult)
        }, reject)
      }
    })
  }

  isAccessTokenValid (token, expiresAt) {
    return (
      token &&
      expiresAt &&
      Date.now() < expiresAt
    )
  }

  renewTokens (token) {
    const self = this
    return new Promise((resolve, reject) => {
      if (!token) {
        return reject(new Error('Not logged in'))
      }
      self.auth0.checkSession({}, (err, authResult) => {
        if (err) {
          reject(err)
        } else {
          resolve(authResult)
        }
      })
    })
  }

  isAuthenticated (accessToken, expiresAt) {
    return (
      Date.now() < expiresAt &&
      accessToken === true
    )
  }

  // the following 2 methods are not currently used anywhere
  isIdTokenValid (idToken, expiresAt) {
    return idToken &&
      expiresAt && Date.now() < expiresAt
  }

  getIdToken (idToken, expiresAt) {
    return new Promise((resolve, reject) => {
      if (self.isIdTokenValid(idToken, expiresAt)) {
        resolve({idToken, expiresAt, isExistingTokenValid: true})
      } else if (self.isAuthenticated(idToken, expiresAt)) {
        self.renewTokens(idToken).then(authResult => {
          resolve(authResult)
        }, reject)
      } else {
        resolve()
      }
    })
  }
}
